import { FallbackProps } from 'react-error-boundary';
import Error from '../Error/Error';

const ErrorFallback = ({ resetErrorBoundary }: FallbackProps) => {
    return <Error title={'Ocorreu um erro'} actions={[{ label: 'Tentar novamente', onClick: resetErrorBoundary }]} />;
};

export default ErrorFallback;
